<template>
  <v-app id="top">
    <the-header
        :header="header"
        app
        v-on:loggedin="updateConfig"
        v-on:loggedout="updateConfig"
    />
    <the-navigation :nav="nav" app v-on:loggedin="updateConfig"/>
    <v-main>
      <v-snackbar
          v-model="$store.state.message.active"
          :color="$store.state.message.type"
          :timeout="$store.state.message.timeout"
          app
          class="mt-12"
          multi-line
          rounded
          bottom
      >
        <v-layout align-center pr-4>
          <v-icon class="pr-3" dark large>mdi-information-outline</v-icon>
          <v-layout column>
            <v-layout>
              <h2 style="text-transform: capitalize;" class="mb-2">{{$store.state.message.type}}</h2>
            </v-layout>
            <div><span class="ihris-snack-text">{{ $store.state.message.text }}</span></div>
          </v-layout>
        </v-layout>
        <template v-slot:action="{ attrs }">
        <v-btn dark icon v-bind="attrs" @click="$store.commit('closeMessage')">
          <v-icon> mdi-close-circle-outline</v-icon>
        </v-btn>
        </template>
      </v-snackbar>

      <v-dialog v-model="$store.state.progress.enabled" persistent width="300">
        <v-card color="primary" dark>
          <v-card-text>
            {{ $store.state.progress.title }}
            <v-progress-linear
                class="mb-0"
                color="white"
                indeterminate
            ></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>

      <router-view :key="$route.path"></router-view>
      <router-view
          v-if="$store.state.user.loggedin"
          :nav="nav"
          name="homeNav"
      ></router-view>
    </v-main>

    <the-footer :footer="footer"/>
  </v-app>
</template>
<script>
import TheHeader from "./components/layout/the-header";
import TheNavigation from "./components/layout/the-navigation";
import TheFooter from "./components/layout/the-footer";

export default {
  name: "App",
  data: () => ({
    header: {
      title: false,
      site: null,
      logo: "iHRIS5Logo.png",
      auths: [],
    },
    footer: {
      links: [],
    },
    nav: {
      active: null,
      menu: {},
      auths: [],
    },
  }),
  components: {
    TheHeader,
    TheNavigation,
    TheFooter,
  },
  methods: {
    updateConfig: function () {
      // make sure we're user has been created in session (logged in or not)
      fetch("/auth").then(() => {
        fetch("/config/site").then((response) => {
          response.json().then((data) => {
            if (
                data.hasOwnProperty("security") &&
                data.security.hasOwnProperty("disabled")
            ) {
              this.$store.commit("securityOff", data.security.disabled);
            }
            if (data.hasOwnProperty("title")) this.header.title = data.title;
            if (data.hasOwnProperty("site")) this.header.site = data.site;
            if (data.hasOwnProperty("logo")) this.header.logo = data.logo;
            if (data.hasOwnProperty("auth")) {
              this.header.auths = [];
              this.nav.auths = [];
              for (let id of Object.keys(data.auth)) {
                data.auth[id].id = id;
                this.header.auths.push(data.auth[id]);
                this.nav.auths.push(data.auth[id]);
              }
            }
            /*if (data.hasOwnProperty("footer")) {
              if (data.footer.hasOwnProperty("links")) {
                for(let id of Object.keys(data.footer.links)) {
                  data.footer.links[id].id = id
                  this.footer.links.push(data.footer.links[id])
                }
              }
            }*/
            if (data.hasOwnProperty("user")) {
              if (data.user.loggedin) {
                let user = {
                  name: data.user.name,
                  location: data.user.location,
                  role: data.user.role,
                  roleName: data.user.roleName,
                  reference: data.user.reference,
                  facilityId: data.user.facilityId,
                  physicalLocation: data.user.physicalLocation
                };
                this.$store.commit("login", user);
              } else {
                this.$store.commit("logout");
              }
            }
            if (data.hasOwnProperty("nav")) {
              if (data.nav.hasOwnProperty("active"))
                this.nav.active = data.nav.active;
              if (data.nav.hasOwnProperty("menu"))
                this.nav.menu = data.nav.menu;
              if (data.nav.hasOwnProperty("home"))
                this.nav.home = data.nav.home;
            }
            let allowed = ["/change-password","/reset-password"]
            let canAllow =  allowed.includes(this.$router.history.current.path)
            // eslint-disable-next-line no-empty
            if (!this.$store.state.user.loggedin&&canAllow) {
            }else if(!this.$store.state.user.loggedin || (this.$store.state.user.loggedin&&canAllow)){
              this.$router.push("/");
            }
          });
        });
      });
    },
  },
  created: function () {
    this.updateConfig();
    fetch("/auth").then(() => {
      fetch("/config/site").then((response) => {
        response.json().then((data) => {
          if (data.hasOwnProperty("footer")) {
            if (data.footer.hasOwnProperty("links")) {
              for (let id of Object.keys(data.footer.links)) {
                data.footer.links[id].id = id;
                this.footer.links.push(data.footer.links[id]);
              }
            }
          }
        });
      });
    });
  },
};
</script>

<style>
.ihris-sections-menu {
  position: sticky;
  top: 0;
  z-index: 2;
}

.ihris-sections-menu::before {
  display: block;
  content: " ";
  margin-top: -70px;
  height: 70px;
  visibility: hidden;
  pointer-events: none;
}

.ihris-section::before {
  display: block;
  content: " ";
  margin-top: -70px;
  height: 70px;
  visibility: hidden;
  pointer-events: none;
}

.ihris-snack-text {
  font-size: medium;
}
</style>
